import React, { useState } from "react";

import Timesheets from "../../InvestmentLending_BorrowerPages/Components/CreateTimesheets";
import ShiftNotes from "./Shift_Notes"

const PaperWorkDropDown: React.FC = () => {
  const [selectedForm, setSelectedForm] = useState<string | null>(null);

  const handleFormChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedForm(event.target.value);
  };

  const renderForm = () => {
    switch (selectedForm) {
      case "form1":
        return <ShiftNotes />;
      case "form2":
        return <Timesheets />;
      case "form3":
        return <Timesheets />;
      default:
        return null;
    }
  };

  const handleSubmit = () => {
    // Handle form submission logic here
    console.log("Form submitted!");
  };

  return (
    <div>
      <select
        style={{ width: "1150px", height: "50px", marginLeft: "200px", fontSize: "16px", fontWeight: "bold",borderRadius: "5px",borderWidth: "5px" }}
        value={selectedForm || ""}
        onChange={handleFormChange}
      >
        <option value="">Select Form</option>
        <option value="form1">Shift Notes</option>
        <option value="form2">HandOver Notes </option>
        <option value="form3">Awake Shift Form</option>
        <option value="form4">Behaviour Recording Form</option>
        <option value="form5">BSL & Ketone Monitoring</option>
        <option value="form6">Buddy Shift Checklist</option>
        <option value="form5">Client Complaints</option>
        <option value="form6">Client Compliments & Feedback </option>
        <option value="form7">Food Intake Chart</option>
        <option value="form8">Incident Report Form</option>
      </select>
      

      {selectedForm && <div style={{ marginTop: "70px",height: "500px", overflow: "auto",  }}>{renderForm()}</div>}
    </div>
  );
};

export default PaperWorkDropDown;
